import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  mode:'history',
  routes: [
    {
      path: "/login",
      name: "Login",
      component: require("@/components/login").default,
      meta: {
        header: false,
      },
    },
    {
      path: "/",
      name: "landing-page",
      component: require("@/components/Homepage").default,
      meta: {
        header: true,
      },
    },
    // {
    //   path: '*',
    //   redirect: '/'
    // }
  ],
});
